<template>
  <div class="text-center">
      <v-card>
        <div class="container-fluid">
          <v-row justify="center" class="col-12">
            <v-col cols="12"> <h1 class="text-center">{{title}}</h1></v-col>
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-row class="col-12">
                <v-col cols="12">
                  <v-text-field
                    color="warning"
                    v-model.trim="form.name"
                    label="Název instituce"
                    prepend-icon="mdi-form-textbox"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-cash-100"
                    v-model.trim="form.deliveryPrice"
                    :rules="[rules.required, rules.number]"
                    label="Cena rozvozu"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-cash-100"
                    v-model.trim="form.minPrice"
                    label="Minimální cena objednávky"
                    :rules="[rules.required, rules.number]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    color="warning"
                    prepend-icon="mdi-home"
                    v-model.trim="form.street"
                    label="Ulice"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    color="warning"
                    v-model.trim="form.streetNumber"
                    label="č.p."
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    v-model.trim="form.city"
                    prepend-icon=" "
                    label="Město"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    v-model.trim="form.zip"
                    label="PSČ"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="warning"
                    v-model.trim="form.phone1"
                    label="Telefon"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="form.cityDistrictId"
                    item-text="name"
                    label="Vyberte městskou část"
                    item-value="id"
                    :items="districts"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    label="Data jsou zkontrolována"
                    v-model="dataChecked"
                    :rules="[rules.checked]"
                    required>
                  </v-checkbox>
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn
                    :disabled="!formValid || wait"
                    color="warning"
                    class="mr-4"
                    @click="save"
                  >
                    Zapsat
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-row>
        </div>
      </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'InstitutionForm',
  props: ['item', 'districts'],
  mixins: [rules],
  data () {
    return {
      wait: false,
      form: {
        ...this.item,
        deliveryPrice: this.item.deliveryPrice.toString(),
        minPrice: this.item.minPrice.toString()
      },
      formValid: true,
      dataChecked: false
    }
  },
  computed: {
    title () {
      return this.item.name ? 'Upravit instituci' : 'Přidat instituci'
    }
  },
  methods: {
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/institutions${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase({
          ...this.form,
          cityDistrictId: this.form.cityDistrictId.toString()
        })
      }
      this.$http(options)
        .then(() => {
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
